import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { soundOn, setSoundOn } from "@/components/holiday/holidaySound";

export const HolidaySoundToggle = ({ theme }) => {
  const { t } = useI18n();
  const [on, setOn] = useState(soundOn);
  const toggle = () => { setSoundOn(!on); setOn(!on); };
  const Icon = on ? Volume2 : VolumeX;
  return (
    <button type="button" onClick={toggle} data-holiday-silent="1" aria-label={t(on ? "hol.snd_off" : "hol.snd_on")} title={t(on ? "hol.snd_off" : "hol.snd_on")}
      className="fixed bottom-4 left-4 z-[60] grid place-items-center w-9 h-9 rounded-full bg-[#0b0c18]/80 backdrop-blur-md border transition-[transform,opacity] duration-200 hover:scale-110 opacity-80 hover:opacity-100"
      style={{ borderColor: `${theme.color}66`, color: on ? theme.color : "#8b8fa8", boxShadow: on ? `0 0 14px -4px ${theme.color}` : "none" }}
      data-testid="holiday-sound-toggle" data-on={on ? "1" : "0"}>
      <Icon className="w-4 h-4" />
    </button>
  );
};
